import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/home/index.vue'
import Merchant from '../views/merchant/index.vue'
import News from '../views/news/index.vue'
import Details from '../views/news/details.vue'
import Help from '../views/help/index.vue'
const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/merchant',
    component: Merchant
  },
  {
    path: '/news',
    children: [
      {
        path: "",
        component: News
      },
      {
        path: "details/:id",
        component: Details
      }
    ]
  },
  {
    path: '/help',
    component: Help
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
